<template>
    <div class="f-wrap">
        <div class="f-item" v-for="(item,index) in items" v-if="index !== 1*currItem">
            <a class="f-item-link" :href="(item.link?item.link:'javascript:;')">
                <i class="iconfont" :class="item.icon"></i>
                {{item.label}}
            </a>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'FloatWindow',
    props: {
      items: {
        type: Array,
        default () {
          return [{
            icon: 'iconchengshi1',
            label: '最近投递'
          }, {
            icon: 'iconchengshi1',
            label: '最近投递'
          }]
        }
      },
      currItem: {
        type: String,
        default: sessionStorage.getItem('kzp_pc_float_item') || '0'
      }
    },
    methods: {
      setItem (index) {
        sessionStorage.setItem('kzp_pc_float_item', index)
      }
    }
  }
</script>

<style scoped lang="scss">
    .f-wrap {
        position: fixed;
        right: calc((100% - 1200px) / 2 - 80px);
        top: 40%;
        width: 50px;

        .f-item {
            text-align: center;
            margin: 20px 0px;

            .iconfont {
                display: block;
                font-size: 25px;
            }

            a:hover {
                color: #007fff;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/FloatWindow/FloatWindow.vue